// HUB3A - sadrzaj 2D koda na hrvatskom nalogu za placanje.
//
// Tocno 14 redaka, ovim redom i s ovim duljinama:
//
//    1 HRVHUB30             8 primatelj adresa (25)
//    2 valuta (3)           9 primatelj sjediste (27)
//    3 iznos (15)          10 IBAN primatelja (21)
//    4 platitelj (30)      11 model (4)
//    5 platitelj adresa(27)12 poziv na broj (22)
//    6 platitelj sjed. (27)13 sifra namjene (4)
//    7 primatelj (25)      14 opis placanja (35)
//
// Platitelj je onaj TKO PLACA: na virmanu nasa firma, na racunu kupac.
//
// Drzi se na jednom mjestu jer je prije svaki ekran imao svoju kopiju, pa su
// se razisle - u virmanu su platitelj i primatelj bili zamijenjeni, iznos bez
// decimala ispadao je kriv, a zadnji redak je bio "undefined".

const DULJINE = [8, 3, 15, 30, 27, 27, 25, 25, 27, 21, 4, 22, 4, 35]

const BEZ_KVACICA = {
  'č': 'c', 'ć': 'c', 'ž': 'z', 'š': 's', 'đ': 'd',
  'Č': 'C', 'Ć': 'C', 'Ž': 'Z', 'Š': 'S', 'Đ': 'D'
}

/**
 * PDF417 u tekstualnom nacinu nosi samo ASCII, pa slova s kvacicama treba
 * zamijeniti - u nalogu je naziv samo informativan i placanje ne ovisi o njemu.
 */
export const ascii = (v) => String(v === null || v === undefined ? '' : v)
  .replace(/[čćžšđČĆŽŠĐ]/g, z => BEZ_KVACICA[z])
  // eslint-disable-next-line no-control-regex
  .replace(/[^\x20-\x7E]/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()

/**
 * Iznos bez decimalne tocke, 15 znamenki s vodecim nulama: 98,75 daje
 * 000000000009875. Racuna se preko centa, da iznos bez decimala ("50") ne
 * zavrsi kao 50,50.
 */
export const iznos15 = (v) => {
  const n = Math.round(Math.abs(parseFloat(v) || 0) * 100)
  const s = String(n)
  return s.length >= 15 ? s.substring(s.length - 15) : '0'.repeat(15 - s.length) + s
}

/** Spaja dijelove adrese u jedan redak, bez praznina na krajevima. */
export const redak = (...dijelovi) => dijelovi.map(x => ascii(x)).filter(x => x).join(' ')

/**
 * Ulica i kucni broj. U sifrarniku partnera broj je cesto vec upisan u ulicu
 * ("V. Nazora 3 PRIBISLAVEC" + broj "3"), pa se ne dodaje drugi put.
 */
export const adresa = (ulica, broj) => {
  const u = ascii(ulica)
  const b = ascii(broj)
  if (!b) { return u }
  if (!u) { return b }
  return new RegExp('(^|\\s)' + b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$').test(u)
    ? u
    : u + ' ' + b
}

/**
 * Postanski broj i mjesto. Mjesto je cesto upisano zajedno s brojem
 * ("40000 CAKOVEC"), pa se broj ne stavlja ispred jos jednom.
 */
export const mjesto = (postanski, grad) => {
  const p = ascii(postanski)
  const g = ascii(grad)
  if (!p) { return g }
  if (!g) { return p }
  return g.indexOf(p) === 0 ? g : p + ' ' + g
}

/**
 * Sadrzaj koda. Ocekuje:
 *   iznos, platiteljIme, platiteljAdresa, platiteljMjesto,
 *   primateljIme, primateljAdresa, primateljMjesto,
 *   iban, model, poziv, namjena, opis
 */
export const hub3Tekst = (p) => {
  const o = p || {}
  return [
    'HRVHUB30',
    ascii(o.valuta) || 'EUR',
    iznos15(o.iznos),
    ascii(o.platiteljIme),
    ascii(o.platiteljAdresa),
    ascii(o.platiteljMjesto),
    ascii(o.primateljIme),
    ascii(o.primateljAdresa),
    ascii(o.primateljMjesto),
    ascii(o.iban).replace(/\s/g, ''),
    ascii(o.model) || 'HR99',
    ascii(o.poziv),
    ascii(o.namjena) || 'COST',
    ascii(o.opis)
  ].map((r, i) => r.substring(0, DULJINE[i])).join('\n')
}

export default hub3Tekst
